<template>
  <!-- footer 1 -->
  <div class="footer-mx">
    <b-row
      class="px-md-5 pt-2"
    >
      <b-col
        xl="9"
        md="6"
        sm="12"
        class="align-self-center"
      >
        <img
          :src="require('@/assets/images/logomenu.png')"
          class="img-fluid"
          alt="men"
        >
        <p class="mt-2 line-height-condensed">
          PT Indosat Tbk, Jl. Medan Merdeka Barat No. 21<br>
          Kel. Gambir, Kec. Gambir, Jakarta Pusat,<br>
          DKI Jakarta, 10110 – Indonesia
        </p>
      </b-col>
      <b-col
        xl="3"
        md="6"
        sm="12"
        class="align-self-center"
      >
        <p class="font-weight-bolder">
          Email
        </p>
        <p>
          support@ioh.id
        </p>
        <p class="font-weight-bolder mt-2">
          Call Center
        </p>
        <p>
          Telp: (+6221) 3000 3001, Fax: (+6221) 3000 3757
        </p>
      </b-col>
    </b-row>
    <div class="d-flex justify-content-between border-top pt-1">
      <div
        class="align-self-start px-md-3 pt-25"
      >
        <p
          class="font-weight-bolder"
        >
          Copyright © 2022 PT Indosat Tbk
        </p>
      </div>
      <div
        class="align-self-start px-md-3"
      >
        <div class="nav-comunication">
          <a
            href="https://api.whatsapp.com/send?phone=6289652315009&text=Halo,%203Ads!%20Mohon%20bantuannya%20untuk%20jelaskan%20informasi%20detail%20platform%203Ads%20ini,%20terima%20kasih."
            target="_blank"
          >
            <img
              :src="require('@/assets/images/whatsapp-icon.png')"
              alt=""
              class="m-25"
            >
          </a>
          <a
            href="mailto:support@ioh.id?subject=Help%20for%203Ads%20information&body=Hello%203Ads%20Support.%0D%0A%0D%0ACan%20you%20help%20me%20to%20explain%20all%20about%203Ads,%20please?%0D%0A%0D%0AThank%20you%0D%0AYour%20Valuable%20Partner."
          >
            <img
              :src="require('@/assets/images/email-icon.png')"
              alt=""
              class="m-25"
            >
          </a>
          <a
            href="tel:(+62) 89652315009"
          >
            <img
              :src="require('@/assets/images/sms-icon.png')"
              alt=""
              class="m-25"
            >
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  BRow,
  BCol,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
  },
}
</script>
